import React from 'react';
import { Box, Carousel, Chip } from '@drone-js/core';
import {
    getAvailableFilters,
    getDisplayOrderFilters,
    getRequestFormatFilters,
    getSelectedFiltersType,
} from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortAndFilter.utils';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, SortFilterProps } from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortAndFilter.selectors';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesReviewFilterChipClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesReviewFilterChipClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import ReviewSortChip from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortChip';

const ReviewSortFilterChips: React.FC<SortFilterProps> = (props) => {
    const availableReviewFilters = React.useMemo(
        () => getAvailableFilters(props.filterMatrix, props.contentLocale, props.cms),
        [props.cms, props.contentLocale, props.filterMatrix],
    );
    const currentSelectedFiltersType = getSelectedFiltersType(props.currentFilter);
    const { onFilterChangeCreator, activityId, currentSort } = props;
    const onFilterChange = React.useMemo(() => onFilterChangeCreator(activityId, currentSort), [activityId, onFilterChangeCreator, currentSort]);

    const onFilterChipClick = (filterType: string, index: number) => {
        const isDeselectProduct = currentSelectedFiltersType.includes(filterType);
        const updatedSelectedFiltersType = isDeselectProduct ? currentSelectedFiltersType.filter((item) => item !== filterType) : [...currentSelectedFiltersType, filterType];

        const selectedFilters = availableReviewFilters.filter((item) => updatedSelectedFiltersType.includes(item.type));
        trackElementEvent<ActivitiesReviewFilterChipClickEventActivitiesFieldsV1>(
            ActivitiesReviewFilterChipClickEventActivitiesManifestV1.ids,
            {},
            {
                action_element_value: `${props.currentSort.type},${updatedSelectedFiltersType.join(',')}`,
                action_element_index: index + 1,
            },
        );
        const requestFilters = getRequestFormatFilters(props.currentFilter, selectedFilters);
        onFilterChange(requestFilters);
    };

    const displayOrderFilters = getDisplayOrderFilters(availableReviewFilters, currentSelectedFiltersType);

    if (!displayOrderFilters || displayOrderFilters.length === 0) {
        return <ReviewSortChip />;
    }

    return props.screenSize.tabletOrDesktop ? (
        <Box display="inline-flex" mt="16">
            <Box me="8" mb="12">
                <ReviewSortChip />
            </Box>
            {displayOrderFilters.map((item, key) => (
                <Chip
                    data-element-name="activities-review-filter-chip"
                    data-testid="activities-review-filter-chip"
                    data-element-index={key + 1}
                    key={key}
                    label={item.label}
                    me="8"
                    mb="12"
                    onClick={() => onFilterChipClick(item.type, key)}
                    selection={currentSelectedFiltersType.includes(item.type) ? 'selected' : 'unselected'}
                />
            ))}
        </Box>
    ) : (
        <Carousel data-testid="activities-review-sort-filter-carousel" mt="16">
            <ReviewSortChip />
            {displayOrderFilters.map((item, key) => (
                <Chip
                    data-element-name="activities-review-filter-chip"
                    data-testid="activities-review-filter-chip"
                    data-element-index={key + 1}
                    key={key}
                    label={item.label}
                    onClick={() => onFilterChipClick(item.type, key)}
                    selection={currentSelectedFiltersType.includes(item.type) ? 'selected' : 'unselected'}
                />
            ))}
        </Carousel>
    );
};
ReviewSortFilterChips.displayName = 'ReviewSortFilterChips';

export default connect(mapStateToProps, mapDispatchToProps)(ReviewSortFilterChips);
